import type { Nullish } from '@iheartjane/types';

export const SEO_PAGE_TYPES = [
  'category',
  'customRow',
  'deal',
  'featured',
  'pdp',
  'shopAll',
] as const;

export type SEOPageType = (typeof SEO_PAGE_TYPES)[number];

export interface CustomSEOPage {
  description?: Nullish<string>;
  title?: Nullish<string>;
}

export type CustomSEO = Partial<Record<SEOPageType, CustomSEOPage>>;
